export function useSyncActiveLocations() {}
